// Email regex from: https://emailregex.com/
export const EMAIL_REG =
  // eslint-disable-next-line max-len
  /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const USERNAME_REG = /^\w+$/;
export const ZIPCODE_REG = /^[0-9]{0,5}/g;

export const validateRegEx = (text: string, reg: RegExp) => {
  if (reg.test(text) === false && text != '') {
    return false;
  }
  return true;
};

export const filterRegEx = (text: string, reg: RegExp): string => {
  const filtered = text.match(reg);
  if (filtered) {
    return filtered?.join('');
  }
  return '';
};
